export default {
    googleMapsKey: "AIzaSyAEED9iCwz71U-gtb7Ulk3pb7SfAS-gtTQ",
    isNode: typeof process === "object" && {}.toString.call(process) === "[object process]"
}